
  export default {
    data() {
      return {
        displayFullSize: true
      }
    },
    computed: {
      downloadPlayerExcelFilter() {
        return this.$store.state.report.downloadPlayerBetExcelFilter
      },
      isDownloadPlayerExcelModalOpen() {
        return this.$store.state.players.downloadPlayerExcelFilter.isOpenModal
      },
      progressLinearValue() {
        const value =
          (this.downloadPlayerExcelFilter.currentPage / this.downloadPlayerExcelFilter.totalPages) *
          100
        if (value >= 100 && this.downloadPlayerExcelFilter.loading) {
          return 99.9
        }

        return value
      },
      timeLeftInMilSeconds() {
        // progressLinearValue
        const progressPercentageLeft = 100 - parseFloat(this.progressLinearValue || 0)

        return (
          (progressPercentageLeft * this.downloadPlayerExcelFilter.estimatedTimePerApiRequest) /
          1000
        )
      }
    },
    methods: {
      formatDurationFromSeconds(seconds) {
        const minutes = parseInt(Math.floor(seconds / 60))
        const remainingSeconds = parseInt(seconds % 60)
        if (minutes < 0) {
          return `${seconds}s`
        }
        return `${minutes}m ${remainingSeconds.toString().padStart(2, '0')}s`
      }
    }
  }
